import queryString from 'query-string';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { Layout } from 'common/components/layout';
import { isValid } from 'common/helpers/dateHelper';
import {
  listReservationAvailabilities,
  resetReservationAvailability
} from 'redux/reservationAvailabilities/actions';

import { createSearchString, urlHistoryString } from './helpers';
import AvailabilityList from './list/AvailabilityList';
import SearchForm from './search/SearchForm';

class Availability extends Component {
  componentDidMount() {
    const { location, settings } = this.props;
    const queryObj = queryString.parse(location.search);
    if (
      queryObj.reservationDate &&
      queryObj.guestCount &&
      queryObj.reservationTime &&
      settings.data
    ) {
      this.handleSearch(queryObj);
    }
  }

  componentDidUpdate(prevProp) {
    const { props } = this;
    const { location } = this.props;
    if (!prevProp.settings.data && props.settings.data) {
      const queryObj = queryString.parse(location.search);
      if (
        queryObj.reservationDate &&
        queryObj.guestCount &&
        queryObj.reservationTime
      ) {
        this.handleSearch(queryObj);
      }
    }
  }

  handleSearch = (params) => {
    // params needs to be reservationDate, guestCount, reservationTime, and optionally reservationTypeId
    const { props } = this;
    if (!isValid(params.reservationDate)) {
      props.history.push(`/reservation/availability`);
    } else {
      const searchString = createSearchString(params, props.settings);
      const historyString = urlHistoryString(params);
      props.resetReservationAvailability();
      props.listReservationAvailabilities(searchString, 'Availability');
      props.history.push(`/reservation/availability?${historyString}`);
    }
  };

  render() {
    const { settings, location } = this.props;
    const queryObj = queryString.parse(location.search);
    if (!settings.data) {
      return (
        <Layout title="Reservations" loading>
          &nbsp;
        </Layout>
      );
    }

    if (queryObj.reservationDate && !isValid(queryObj.reservationDate)) {
      return <Redirect to="/reservation/availability" />;
    }

    return (
      <Layout title="Reservations">
        <SearchForm
          onSearch={this.handleSearch}
          reservationDate={queryObj.reservationDate}
          guestCount={queryObj.guestCount}
          reservationTime={queryObj.reservationTime}
          reservationTypeId={queryObj.reservationTypeId}
        />

        <AvailabilityList
          onSearch={this.handleSearch}
          reservationDate={queryObj.reservationDate}
          guestCount={queryObj.guestCount}
          reservationTime={queryObj.reservationTime}
          reservationTypeId={queryObj.reservationTypeId}
        />
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  settings: state.setting
});

export default connect(mapStateToProps, {
  listReservationAvailabilities,
  resetReservationAvailability
})(Availability);
